import { fbqTrack } from "./eventsTracking/fbq";
import { gtagEvent } from "./eventsTracking/gtag";
import { shouldTrackEvents } from "./eventsTracking/shouldTrackEvents";

export const trackCTA = (label) => {
  if (!shouldTrackEvents()) return;

  fbqTrack('ViewContent', {
    content_name: label,
    content_category: 'CTA',
    page: window.location.href
  });
  gtagEvent('view_item', {
    item_id: `cta_${label.toLowerCase().replace(/\s+/g, '_')}`,
    item_name: label,
    item_category: 'CTA',
    page_location: window.location.href
  });
};
